// Economic Calendar Constants
// Extracted from JournalView.js for modular organization

// Common market event tags for quick selection
export const EVENT_TAGS = [
  'FOMC', 'CPI', 'NFP', 'PPI', 'GDP', 'Retail Sales', 'Jobless Claims',
  'Fed Speech', 'Earnings', 'Quad Witching', 'OPEX', 'Holiday', 
  'Low Volume', 'High Volatility', 'News Event'
];

// Common economic events for quick add with default importance levels
export const COMMON_EVENTS = [
  { name: 'FOMC Meeting', importance: 'high' },
  { name: 'CPI Report', importance: 'high' },
  { name: 'NFP (Non-Farm Payrolls)', importance: 'high' },
  { name: 'PPI Report', importance: 'medium' },
  { name: 'GDP Report', importance: 'high' },
  { name: 'Retail Sales', importance: 'medium' },
  { name: 'Jobless Claims', importance: 'medium' },
  { name: 'Fed Chair Speech', importance: 'high' },
  { name: 'PMI Report', importance: 'medium' },
  { name: 'Consumer Confidence', importance: 'low' },
  { name: 'Housing Data', importance: 'low' },
  { name: 'Earnings Release', importance: 'medium' },
];

// Importance level configurations
export const IMPORTANCE_LEVELS = {
  high: {
    label: 'High',
    emoji: '🔴',
    color: 'red',
    bgClass: 'bg-red-500',
    textClass: 'text-red-500'
  },
  medium: {
    label: 'Medium',
    emoji: '🟡',
    color: 'yellow',
    bgClass: 'bg-yellow-500',
    textClass: 'text-yellow-500'
  },
  low: {
    label: 'Low',
    emoji: '🔵',
    color: 'blue',
    bgClass: 'bg-blue-500',
    textClass: 'text-blue-500'
  }
};

// Default currencies to filter for (for future API integration)
export const DEFAULT_CURRENCIES = ['USD'];

// Default time zone for event times — sourced from timeService so all
// session-time anchors live in one place.
export { SESSION_TZ as DEFAULT_TIMEZONE } from '../../services/timeService';
